import { Directive, inject } from '@angular/core';
import { PaneDataLoaderService } from '@app/_v3/services/pane-data-loader.service';
import { LibraryRouter } from '@models/library.router';
import { Store } from '@ngrx/store';
import { getLibraryRouteData } from '@store/reducers/library.reducer';
import { Collection, CollectionDetailsType, IPagination } from 'lingo2-models';
import { switchMap, takeUntil } from 'rxjs/operators';
import { CollectionsService } from '../../../core/services';
import { AbstractPane } from './abstract-pane';

@Directive()
// tslint:disable-next-line:directive-class-suffix
export abstract class AbstractCollectionPane extends AbstractPane {
  public contentRoute = LibraryRouter.contentRouteUniversal;
  public collectionRoute = LibraryRouter.collectionRouteUniversal;
  protected libRouter: LibraryRouter;
  protected readonly collectionsService = inject(CollectionsService);
  protected readonly store = inject(Store);

  constructor() {
    super();

    this.libRouter = new LibraryRouter({});
    this.store
      .select(getLibraryRouteData)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (data) => {
          if (!data) return;
          this.libRouter.setBaseRoute(data.baseRoute);
          this.libRouter.setSubjects(data.subjectCodes);
          this.libRouter.setContentTypes(data.contentTypeCodes);
          if (!data.isDefaultOnlyLanguages) {
            this.libRouter.setLanguageCodes(data.languageCodes);
          }
          this.onLibraryRoute();
        },
        error: (error) => {
          this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
        },
      });
  }

  public get collections(): Collection[] {
    return this._pane?.contentItems || this._pane?.collections || [];
  }

  override hasContent(): boolean {
    return !!this.collections?.length;
  }

  override load(): void {
    if (!this._pane) return;

    this.onLibraryRoute();
    super.loadPane();
  }

  protected onLibraryRoute(): void {
    if (this._pane) {
      this.addLink = this._pane.routerUrlCreate ?? this.libRouter.getCreateLinkByPane(this._pane);
      this.seeAllLink = !this._pane.routerUrlAll
        ? this.libRouter.getSeeAllLinkByPane(this._pane)
        : this._pane.routerUrlAll;

      this.titleLink = this.seeAllLink;
    } else {
      this.addLink = '';
      this.seeAllLink = '';
      this.titleLink = '';
    }

    this.blockTitle = {
      ...this.blockTitle,
      add_link: this.addLink,
      see_all_link: this._pane?.infinity ? '' : this.seeAllLink,
      title_link: this.titleLink,
    };
    this.markForCheck();
  }

  // protected get details(): CollectionDetailsType[] {
  //   return [
  //     'id',
  //     'slug',
  //     'author:sm',
  //     'title',
  //     'excerpt',
  //     'subject',
  //     'language',
  //     'multi_cover:sm',
  //     'moderation_status',
  //     'publish_status',
  //     'stats',
  //     'valid',
  //     'visit_info',
  //   ];
  // }
}
